<template>
  <div class="wrapper-landing lbn">

    <!-- ─── HERO ─── -->
    <header class="lbn-hero" ref="heroRef">
      <div class="lbn-hero__bg" aria-hidden="true"></div>

      <div class="lbn-hero__logo">
        <router-link to="#">
          <img src="../../assets/img/logos/logo-hellowish-dark.webp" alt="HelloWish" />
        </router-link>
      </div>

      <div class="lbn-hero__content">
        <h1 class="lbn-hero__title">
          Checklist: <em>todo</em> lo que tu bebé necesitará
        </h1>
        <p class="lbn-hero__subtitle">
          Descubre lo que más de 100.000 mamás suelen poner en sus listas de nacimiento con HelloWish
        </p>
        <button class="lbn-btn-scroll" @click="scrollToList">
          Ver checklist
          <span class="lbn-btn-scroll__arrow" aria-hidden="true">↓</span>
        </button>
      </div>

      <div class="lbn-hero__cover lbn-hero__cover--bleed">
        <img
          class="lbn-hero__img"
          src="../../assets/img/covers/landing-edu.webp"
          alt=""
          loading="eager"
        />
      </div>
    </header>

    <!-- ─── SECCIÓN LISTA ─── -->
    <section class="lbn-section" ref="listaSection">
      <div class="lbn-lista-wrap">

        <h2 class="lbn-section-title">Un checklist para tu bebé usando HelloWish</h2>

        <!-- Cabecera de lista -->
        <div class="lbn-list-header">
          <img v-if="ownerPhoto" class="lbn-list-avatar" :src="ownerPhoto" alt="" />
          <div>
            <h2 class="lbn-list-header-name">{{ listTitle }}</h2>
            <p v-if="welcomeMessage" class="lbn-list-header-welcome">{{ welcomeMessage }}</p>
          </div>
        </div>

        <!-- Productos agrupados por categoría -->
        <div v-for="group in productosByCategory" :key="group.category" class="lbn-category-group">
          <h3 v-if="group.category" class="lbn-category-title">{{ group.category }}</h3>
          <div class="lbn-product-list">
          <article
            v-for="(p, i) in group.items"
            :key="i"
            class="lbn-card"
          >
            <!-- Imagen -->
            <section class="lbn-card__left" v-if="p.photo">
              <div class="lbn-card__img-wrap">
                <img
                  class="lbn-card__img"
                  :src="p.photo"
                  :alt="p.name"
                  loading="lazy"
                />
              </div>
            </section>

            <!-- Contenido -->
            <aside class="lbn-card__right">
              <!-- Imprescindible -->
              <div class="lbn-card__musthave" v-if="p.mustHave">
                <img src="../../assets/img/ico/ico-heart-fill.svg" alt="" width="14" height="14" />
                Sandra lo ha marcado como imprescindible
              </div>

              <!-- Título -->
              <h3 class="lbn-card__title">{{ p.name }}</h3>

              <!-- Comentario / apunte -->
              <div class="lbn-card__comments" v-if="p.note">
                <p class="lbn-card__comments-label">HelloWish ha dejado un comentario:</p>
                <p class="lbn-card__comments-text">{{ p.note }}</p>
              </div>

              <!-- Precio -->
              <div class="lbn-card__price-row" v-if="p.price">
                <span class="lbn-card__price-label">Presupuesto estimado</span>
                <span class="lbn-card__price-val">{{ p.price }} €</span>
              </div>

              <!-- Retailer + CTA -->
              <div class="lbn-card__footer">
                <p class="lbn-card__retailers-label" v-if="p.retailerLogo">Añadido a la lista desde:</p>
                <div class="lbn-card__footer-row">
                  <div class="lbn-card__retailers-list" v-if="p.retailerLogo">
                    <span class="lbn-retailer-chip">
                      <img class="lbn-retailer-chip__logo" :src="p.retailerLogo" alt="" />
                    </span>
                  </div>
                  <button class="lbn-card__copy-btn" @click="onCopyList">
                    <i class="uil uil-list-ul" aria-hidden="true"></i>
                    Cópialo a tu lista
                  </button>
                </div>
              </div>
            </aside>
          </article>
          </div>
        </div>

      </div>
    </section>

    <!-- ─── STICKY CTA ─── -->
    <div class="lbn-sticky" v-show="showStickyCta" role="complementary">
      <p class="lbn-sticky__text">Crea tu propia lista a partir del checklist</p>
      <button class="lbn-sticky__btn" @click="onCopyList">Copiar checklist</button>
    </div>

    <!-- ─── CIERRE ─── -->
    <section class="lbn-cierre" ref="cierreSection">
      <div class="lbn-lista-wrap lbn-lista-wrap--center">
        <div class="lbn-final">
          <h2 class="lbn-final__title">
            Copia y adapta este checklist
          </h2>
          <p class="lbn-final__sub">
            Crea tu propia lista usándolo como punto de partida.
          </p>
          <button class="lbn-btn-final" @click="onCopyList">
            Copiar checklist
          </button>
        </div>
      </div>
    </section>

    <LandingFooter />
  </div>
</template>

<script>
import LandingFooter from "./components/LandingFooter.vue";
import axios from "axios";

const IMG = "https://images.hellobb.net/";
const LOGO_IMG = "https://images.hellobb.net/logos/";

export default {
  name: "LandingBabyNeeds",
  components: { LandingFooter },
  metaInfo() {
    return {
      title: "¿Qué necesita un bebé? Lista completa de nacimiento — HelloWish",
      meta: [
        {
          name: "description",
          content:
            "Descubre la lista completa de todo lo que necesita un bebé. Más de 100.000 mamás ya la usan como guía con HelloWish.",
        },
        { name: "robots", content: "noindex" },
      ],
    };
  },
  data() {
    return {
      heroVisible: true,
      cierreVisible: false,
      ioHero: null,
      ioCierre: null,
      ownerPhoto: null,
      listTitle: '',
      welcomeMessage: '',
      productos: [],
    };
  },
  computed: {
    showStickyCta() {
      return !this.heroVisible && !this.cierreVisible;
    },
    productosByCategory() {
      const ORDER = [
        'de paseo',
        'a comer',
        'en el coche',
        'hogar',
        'a jugar',
        'baño y cuidados',
        'para mamá',
        'ropa',
      ];
      const map = new Map();
      for (const p of this.productos) {
        const cat = p.category || '';
        if (!map.has(cat)) map.set(cat, []);
        map.get(cat).push(p);
      }
      return Array.from(map.entries())
        .map(([category, items]) => ({ category, items }))
        .sort((a, b) => {
          const ia = ORDER.indexOf(a.category.toLowerCase());
          const ib = ORDER.indexOf(b.category.toLowerCase());
          const pa = ia === -1 ? Infinity : ia;
          const pb = ib === -1 ? Infinity : ib;
          return pa - pb;
        });
    },
  },
  async mounted() {
    const heroEl = this.$refs.heroRef;
    if (heroEl) {
      this.ioHero = new IntersectionObserver(
        ([entry]) => { this.heroVisible = entry.isIntersecting; },
        { threshold: 0 }
      );
      this.ioHero.observe(heroEl);
    }
    const cierreEl = this.$refs.cierreSection;
    if (cierreEl) {
      this.ioCierre = new IntersectionObserver(
        ([entry]) => { this.cierreVisible = entry.isIntersecting; },
        { threshold: 0 }
      );
      this.ioCierre.observe(cierreEl);
    }

    try {
      const isProd = process.env.API === 'https://hellobb-api.azurewebsites.net/api';
      const listId = isProd ? 'ERnM' : 'lxA6';
      const { data } = await axios.get(`${process.env.API}/list/minimal/${listId}`);
      const USER_IMG = process.env.URL_IMG_USER;
      this.ownerPhoto = data.photo ? `${USER_IMG}${data.photo.replace(USER_IMG, '')}` : null;
      this.listTitle = data.title || '';
      this.welcomeMessage = data.welcomeMessage || '';
      this.productos = data.products.map(p => ({
        category:     p.mainCategory || '',
        name:         p.title,
        photo:        p.photo ? `${IMG}${p.photo.replace(IMG, '')}` : null,
        note:         p.info || null,
        mustHave:     p.mustHave,
        price:        p.price != null ? new Intl.NumberFormat('es-ES', { minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(Math.round(p.price)) : null,
        retailerLogo: p.retailerLogo ? `${LOGO_IMG}${p.retailerLogo.replace(LOGO_IMG, '')}?tr=w-88,h-88,cm-pad_resize` : null,
      }));
    } catch (e) {
      // fail silently, la lista queda vacía
    }
  },
  beforeDestroy() {
    if (this.ioHero)   { this.ioHero.disconnect();   this.ioHero   = null; }
    if (this.ioCierre) { this.ioCierre.disconnect(); this.ioCierre = null; }
  },
  methods: {
    scrollToList() {
      const el = this.$refs.listaSection;
      if (!el) return;
      const top = el.getBoundingClientRect().top + window.pageYOffset - 16;
      window.scrollTo({ top, behavior: "smooth" });
    },
    onCopyList() {
      this.$router.push({ name: "landing-signup-baby-needs" });
    },
  },
};
</script>

<style>
/* ── HERO ────────────────────────────────────────────────── */
.lbn-hero {
  background: #FFCC00;
  min-height: 100svh;
  display: flex;
  flex-direction: column;
  position: relative;
  padding: 32px 24px 56px;
}
.lbn-hero__bg {
  position: absolute;
  inset: 0;
  overflow: hidden;
  pointer-events: none;
  z-index: 0;
}
.lbn-hero__bg::before,
.lbn-hero__bg::after {
  content: '';
  position: absolute;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.07);
}
.lbn-hero__bg::before { width: 360px; height: 360px; top: -120px; right: -100px; }
.lbn-hero__bg::after  { width: 280px; height: 280px; bottom: -100px; left: -80px; }

.lbn-hero__logo {
  align-self: flex-start;
  flex-shrink: 0;
  margin-bottom: 32px;
  z-index: 1;
  position: relative;
}
.lbn-hero__logo img { width: 120px; height: auto; display: block; }

.lbn-hero__content {
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 1;
  text-align: center;
}
.lbn-hero__title {
  font-size: clamp(32px, 8vw, 52px);
  font-weight: 700;
  color: #312A5E;
  line-height: 1.15;
  letter-spacing: -1.5px;
  margin-bottom: 16px;
}
.lbn-hero__title em { font-style: normal; color: #fff; }
.lbn-hero__subtitle {
  font-size: 17px;
  color: #312A5E;
  opacity: 0.8;
  line-height: 1.6;
  margin-bottom: 32px;
}

.lbn-btn-scroll {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #5d50c6;
  color: #fff;
  font-family: inherit;
  font-size: 17px;
  font-weight: 800;
  padding: 18px 36px;
  border-radius: 50px;
  border: none;
  cursor: pointer;
  letter-spacing: -0.2px;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
  box-shadow: 0 4px 20px rgba(93, 80, 198, 0.35);
  align-self: center;
}
.lbn-btn-scroll:hover  { transform: translateY(-2px); box-shadow: 0 8px 28px rgba(93, 80, 198, 0.45); background: #473d99; }
.lbn-btn-scroll:active { transform: translateY(0); }
.lbn-btn-scroll__arrow {
  font-size: 20px;
  line-height: 1;
  animation: lbn-bounce 1.8s ease infinite;
}
@keyframes lbn-bounce {
  0%, 60%, 100% { transform: translateY(0); }
  30% { transform: translateY(5px); }
}

.lbn-hero__cover {
  width: 100%;
  margin-top: 40px;
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  position: relative;
  z-index: 1;
  min-height: 200px;
}
.lbn-hero__cover--bleed {
  width: 100vw;
  margin-left: -24px;
  margin-right: -24px;
  margin-bottom: -56px;
}
.lbn-hero__img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: top center;
  display: block;
  mix-blend-mode: multiply;
  animation: lbn-fadein 0.6s 0.3s ease both;
}
@keyframes lbn-fadein {
  from { opacity: 0; transform: translateY(16px); }
  to   { opacity: 1; transform: translateY(0); }
}

@media (min-width: 1024px) {
  .lbn-hero {
    flex-direction: row;
    align-items: center;
    gap: 64px;
    padding: 80px 10%;
    min-height: 100svh;
  }
  .lbn-hero__logo { align-self: flex-start; margin-bottom: 0; }
  .lbn-hero__logo img { width: 140px; }
  .lbn-hero__content { flex: 1; max-width: 480px; text-align: left; }
  .lbn-btn-scroll { align-self: flex-start; }
  .lbn-hero__cover,
  .lbn-hero__cover--bleed { flex-shrink: 0; width: auto; margin: 0; }
  .lbn-hero__img {
    width: clamp(320px, 28vw, 440px);
    -webkit-mask-image:
      linear-gradient(to right, transparent 0%, black 3%, black 97%, transparent 100%),
      linear-gradient(to bottom, transparent 0%, black 2%, black 97%, transparent 100%);
    mask-image:
      linear-gradient(to right, transparent 0%, black 3%, black 97%, transparent 100%),
      linear-gradient(to bottom, transparent 0%, black 2%, black 97%, transparent 100%);
    -webkit-mask-composite: source-in;
    mask-composite: intersect;
  }
}

/* ── Sección lista ───────────────────────────────────────── */
.lbn-section {
  padding: 64px 24px;
  background: #faf8f7;
}
.lbn-lista-wrap {
  max-width: 760px;
  margin: 0 auto;
}
.lbn-lista-wrap--center { text-align: center; }

/* ── Cabecera de lista ───────────────────────────────────── */
.lbn-list-header {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 40px;
}
.lbn-list-avatar {
  width: 90px;
  height: 90px;
  border-radius: 60px;
  object-fit: cover;
  object-position: top;
  border: 4px solid #fff;
  box-shadow: 0 2px 8px rgba(30, 0, 40, 0.15);
  flex-shrink: 0;
}
@media (min-width: 640px) {
  .lbn-list-avatar { width: 108px; height: 108px; }
}
.lbn-list-header-name {
  font-size: clamp(1.25rem, 4vw, 1.875rem);
  font-weight: 600;
  color: #1e0028;
  margin: 0 0 4px;
  letter-spacing: -0.3px;
}
.lbn-list-header-meta {
  font-size: 0.875rem;
  color: #7f7f7f;
  margin: 0;
}
.lbn-list-header-welcome {
  font-size: 0.875rem;
  color: #4b4b4b;
  margin: 4px 0 0;
  line-height: 1.5;
}

/* ── Título de sección ───────────────────────────────────── */
.lbn-section-title {
  font-size: clamp(24px, 5vw, 36px);
  font-weight: 800;
  color: #312A5E;
  line-height: 1.2;
  margin: 0 0 32px;
  letter-spacing: -0.8px;
}

/* ── Grupos de categoría ─────────────────────────────────── */
.lbn-category-group {
  margin-bottom: 2.5rem;
}
.lbn-category-title {
  font-size: clamp(15px, 3vw, 18px);
  font-weight: 700;
  color: #312A5E;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  margin: 0 0 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid #FFCC00;
  display: inline-block;
}

/* ── Lista de cards ──────────────────────────────────────── */
.lbn-product-list {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}
@media (min-width: 768px) {
  .lbn-product-list { gap: 2.5rem; }
}

/* ── Card ────────────────────────────────────────────────── */
.lbn-card {
  background: #fff;
  box-shadow: 0px 8px 16px rgba(30, 0, 40, 0.08);
  border-radius: 0.625rem;
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  padding: 1.25rem 1.25rem 0.75rem;
  transition: box-shadow 0.1s ease-in-out;
}
.lbn-card:hover { box-shadow: 0px 16px 48px rgba(30, 0, 40, 0.1); }
@media (min-width: 768px) {
  .lbn-card { padding: 1.75rem 1.5rem 1.25rem; }
}

/* ── Columna imagen ──────────────────────────────────────── */
.lbn-card__left {
  flex: 0 0 100%;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}
@media (min-width: 560px) { .lbn-card__left { flex: 0 0 200px; } }
@media (min-width: 768px) { .lbn-card__left { flex: 0 0 232px; } }

.lbn-card__img-wrap {
  aspect-ratio: 26 / 17;
  border: 1px solid #d7d7d7;
  border-radius: 0.625rem;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  transition: opacity 0.2s;
  cursor: pointer;
}
.lbn-card__img-wrap--dim { opacity: 0.4; }
@media (min-width: 560px) { .lbn-card__img-wrap { aspect-ratio: 1 / 1; } }

.lbn-card__img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
  padding: 10px;
  box-sizing: border-box;
}

.lbn-card__status-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
}

/* ── Badge ───────────────────────────────────────────────── */
.lbn-badge {
  display: inline-block;
  padding: 6px 16px;
  border-radius: 50px;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.2px;
}
.lbn-badge--accent  { background: #5d50c6; color: #fff; }
.lbn-badge--success { background: #28a745; color: #fff; }

/* ── Botón reservar ──────────────────────────────────────── */
.lbn-btn-reserve {
  width: 100%;
  background: none;
  border: 1.5px solid #d7d7d7;
  border-radius: 8px;
  padding: 10px 16px;
  font-family: inherit;
  font-size: 14px;
  font-weight: 600;
  color: #1e0028;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  transition: border-color 0.15s, background 0.15s;
}
.lbn-btn-reserve:hover  { border-color: #5d50c6; background: #f5f4ff; }
.lbn-btn-reserve--desk  { display: none; }
.lbn-btn-reserve--mob   { display: flex; }
@media (min-width: 560px) {
  .lbn-btn-reserve--desk { display: flex; }
  .lbn-btn-reserve--mob  { display: none; }
}

/* ── Columna contenido ───────────────────────────────────── */
.lbn-card__right {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.lbn-card__musthave {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.875rem;
  font-weight: 500;
  color: #1e0028;
}

.lbn-card__title {
  font-size: 1.125rem;
  font-weight: 600;
  color: #1e0028;
  margin: 0;
  line-height: 1.4;
}

.lbn-card__comments {
  background: #f5f5f5;
  border-radius: 0.625rem;
  padding: 0.875rem;
}
.lbn-card__comments-label {
  font-size: 0.8125rem;
  font-weight: 600;
  color: #1e0028;
  margin: 0 0 4px;
}
.lbn-card__comments-text {
  font-size: 0.875rem;
  color: #4b4b4b;
  margin: 0;
  line-height: 1.5;
}

.lbn-card__price-row {
  display: flex;
  flex-direction: column;
  gap: 2px;
  border-bottom: 1px solid #d7d7d7;
  padding-bottom: 1rem;
}
.lbn-card__price-label {
  font-size: 0.75rem;
  font-weight: 500;
  color: #7f7f7f;
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}
.lbn-card__price-val { font-size: 1.625rem; font-weight: 600; color: #1e0028; letter-spacing: -0.5px; }

.lbn-card__retailers-label {
  font-size: 0.8125rem;
  font-weight: 500;
  color: #1e0028;
  margin: 0 0 10px;
}
.lbn-card__retailers-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.lbn-retailer-chip {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  border: 1px solid #d7d7d7;
  background: #fff;
  flex-shrink: 0;
  overflow: hidden;
  display: inline-flex;
}
.lbn-retailer-chip__logo {
  width: 100%;
  height: 100%;
  display: block;
}
.lbn-card__footer {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: auto;
}
.lbn-card__footer-row {
  display: flex;
  align-items: center;
  gap: 12px;
}
.lbn-card__copy-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #f0eeff;
  color: #5d50c6;
  border: 1px solid rgba(93, 80, 198, 0.18);
  border-radius: 50px;
  padding: 7px 14px;
  font-size: 13px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
  margin-left: auto;
  transition: background 0.15s ease;
}
.lbn-card__copy-btn:hover { background: #e4deff; }
.lbn-card__copy-btn .uil { font-size: 15px; line-height: 1; }

.lbn-retailer-chip__name {
  font-size: 9px;
  font-weight: 700;
  text-align: center;
  line-height: 1.2;
  color: #1e0028;
}

/* ── Sticky CTA ──────────────────────────────────────────── */
.lbn-sticky {
  position: fixed;
  bottom: 0; left: 0; right: 0;
  z-index: 1000;
  background: #312A5E;
  border-top: 2px solid #FFCC00;
  padding: 12px 20px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  box-shadow: 0 -4px 24px rgba(49, 42, 94, 0.3);
  animation: lbn-slide-up 0.4s cubic-bezier(0.16, 1, 0.3, 1) both;
}
@keyframes lbn-slide-up {
  from { transform: translateY(100%); }
  to   { transform: translateY(0); }
}
.lbn-sticky__text {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.8);
  font-weight: 500;
  text-align: center;
  margin: 0;
}
.lbn-sticky__btn {
  width: 100%;
  max-width: 340px;
  background: #FFCC00;
  border: 1px solid #FFCC00;
  border-radius: 50px;
  padding: 14px 24px;
  font-family: inherit;
  font-size: 15px;
  font-weight: 800;
  color: #312A5E;
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  transition: background 0.2s ease, transform 0.15s ease;
}
.lbn-sticky__btn:hover  { background: #f0c000; }
.lbn-sticky__btn:active { transform: scale(0.98); }
@media (min-width: 1024px) {
  .lbn-sticky {
    flex-direction: row;
    justify-content: center;
    gap: 24px;
    padding: 14px 40px;
  }
  .lbn-sticky__btn { width: auto; padding: 12px 36px; }
}

/* ── Cierre ──────────────────────────────────────────────── */
.lbn-cierre {
  padding: 72px 24px;
  background: #fff;
}
@media (min-width: 768px) { .lbn-cierre { padding: 96px 48px; } }

.lbn-final {
  background: #312A5E;
  border-radius: 32px;
  padding: 56px 40px;
  text-align: center;
}
.lbn-final__title {
  font-size: clamp(22px, 4vw, 30px);
  font-weight: 800;
  color: #fff;
  margin-bottom: 12px;
  letter-spacing: -0.5px;
  line-height: 1.3;
}
.lbn-final__sub {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 32px;
  line-height: 1.6;
}
.lbn-btn-final {
  display: inline-block;
  background: #FFCC00;
  color: #312A5E;
  font-family: inherit;
  font-size: 17px;
  font-weight: 800;
  padding: 18px 48px;
  border-radius: 50px;
  border: none;
  cursor: pointer;
  letter-spacing: -0.2px;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
  box-shadow: 0 4px 20px rgba(255, 204, 0, 0.35);
}
.lbn-btn-final:hover  { transform: translateY(-2px); box-shadow: 0 8px 28px rgba(255, 204, 0, 0.4); }
.lbn-btn-final:active { transform: translateY(0); }
.lbn-final__reinforce {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.5);
  margin-top: 12px;
  margin-bottom: 0;
}
</style>
